import React from 'react';
import {Avatar} from "antd";
import {getUserInitials, getAvatarSrc} from "../helpers/functions";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import styled from "styled-components";

const UserAvatar = (props) => {
    const { user, nameType, disabled, hideAvatar, size, fontSize, darkMode, fontColor, boldInitials } = props;
    const name = nameType === 'full' ? user.full_name : nameType === 'firstName' ? user.first_name : '';

    return (
        <span style={{display: 'flex', alignItems: 'center', gap: hideAvatar ? 0 : '10px', minWidth: 0, maxWidth: '100%', overflow: 'hidden'}}>
            {!hideAvatar &&
            <AvatarWrapper size={size ?? 30}
                    src={getAvatarSrc(user)}
                    style={{
                        backgroundColor: darkMode ? Colors.siteBlack : Colors.weekDayDark,
                        color: darkMode ? Colors.white : Colors.siteBlack,
                        flexShrink: 0,
                        fontSize: fontSize ?? '14px',
                        opacity: disabled ? '50%' : '100%',
                        border: '1px solid white',
                        fontWeight: boldInitials ? 'bold' : 'unset'
                    }}>
                {getUserInitials(user)}
            </AvatarWrapper>}
            <EllipsisText style={{opacity: disabled ? '50%' : '100%', color: fontColor ?? Colors.siteBlack}}>{name}</EllipsisText>
        </span>
    );
};

export default UserAvatar;

const EllipsisText = styled.span`
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
`;

const AvatarWrapper = styled(Avatar)`
    .ant-avatar-string {
        line-height: ${({size}) => `${size - 2}px !important`};
    }
`;